import { isInCooldown } from './isInCooldown';
import { MIN_QUALIFYING_CONVERSATIONS } from './MIN_QUALIFYING_CONVERSATIONS';
import { readFromStorage } from './readFromStorage';
import { writeToStorage } from './writeToStorage';

/**
 * Call when the user sends the first valid message of a new conversation.
 * No-op during either cooldown window: the "3 qualifying conversations" gate
 * must demonstrate engagement AFTER the cooldown ends, not during it.
 */
export const recordValidMessage = (): void => {
	const cur = readFromStorage();
	if (isInCooldown(cur)) {
		return;
	}
	if (cur.qualifyingConversations >= MIN_QUALIFYING_CONVERSATIONS) {
		return;
	}
	writeToStorage({
		...cur,
		qualifyingConversations: cur.qualifyingConversations + 1,
	});
};
